import URI from 'urijs'
import { API_BASE } from '../../../shared/constants/Api'

export const CUSTOMERS_LIST = (params) => { return URI(`${API_BASE}/api/v2/customers/`).addSearch(params) }
export const CUSTOMER_INFO = ({id, ...params}) => { return URI(`${API_BASE}/api/v2/customers/${id ? id + '/' : ''}`).addSearch(params) }
export const COMPANY_NAMES_AUTOCOMPLETE = (params) => { return URI(`${API_BASE}/api/v2/roaringio-fetcher/companies-info`).addSearch(params) }
export const CUSTOMER_COMPANY_INFO = ({key, ...params}) => { return URI(`${API_BASE}/api/v2/roaringio-fetcher/companies-info/${key}`).addSearch(params) }
